<script lang="ts">
    export let value: string = '';
    export let disabled: boolean = false;
    export let style: string = '';
    export let className: string = '';
    export let autofocus: boolean = false;
    export let valid: boolean = true;
    export let step: string = '1';
    export let min: string = '0';

    export let check: (value: string) => boolean = (value: string) => true;

    // run check function on keyup
    function onKeyup(event: KeyboardEvent) {
        valid = check(value);
        console.log('onKeyup', valid, value);
        return true;
    }
</script>

<input
    class="input-small {className}"
    {step}
    {min}
    type="number"
    class:invalid-input={!valid}
    bind:value
    {disabled}
    {style}
    on:keydown
    on:keyup={onKeyup}
    on:keypress
    on:change
    on:input={onKeyup}
    {autofocus}
/>

<style>
    .input-small {
        font-size: var(--font-size-tactical-plan);
        /*padding: 4px;*/
        /*padding: 7px;*/
        /*border: 1px solid #ccc;*/
        /*border: 0;*/
        /*border-radius: 5px;*/
        /*min-width: 188px;*/
        outline: 0;
        max-width: 60px;
        /*color: var(--automapa-blue);*/
        text-align: center;
        /*font-weight: 600;*/
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
        border-radius: var(--input-small-border-radius);
    }
    .input-error {
        border-color: var(--automapa-red);
    }
</style>
